// The rebuilt Crystal reports, read live from the Soft-Pak replica through the
// reporting API (backend/src/routes/softpakReports.js).
import ReportRunner from '../components/Reports/ReportRunner';

export default function SoftpakReports() {
  return (
    <ReportRunner
      basePath="/softpak-reports"
      eyebrow="Soft-Pak"
      title="Soft-Pak Reports"
      subtitle="Rebuilt Crystal reports, read live from the Soft-Pak replica (seconds behind the AS400)."
      filePrefix="softpak"
    />
  );
}
